import { Code } from '@.api';
import { DictionaryApi, DictionaryKeysEnum } from '@/Services/api/methods/v2/Dictionary';
import { DictionaryOptionResource } from '@/Services/api/methods/v2/Dictionary/response';
import { DictionaryItem } from '@/Types/api/Dictionaries';

export class StoreClusterService {
    private readonly dictionaryApi: DictionaryApi = new DictionaryApi();

    public async getStoresByCompanies(companiesIds: number[], allStores: DictionaryItem[], selectedStores: DictionaryItem[]): Promise<DictionaryItem[]> {
        const response = await this.dictionaryApi.dictionaries({
            keys: [DictionaryKeysEnum.STORES],
            filters: {
                [DictionaryKeysEnum.STORES]: {
                    companies_ids: companiesIds,
                },
            },
        });

        if (response.code === Code.Success) {
            return this._filterStores(
                this._responseDictionaryOptionToDictionaryItem(response.data.dictionaries[DictionaryKeysEnum.STORES]),
                allStores,
                selectedStores
            );
        }

        return [];
    }

    public async getStoresByStoreGroups(storeGroupIds: number[], allStores: DictionaryItem[], selectedStores: DictionaryItem[]): Promise<DictionaryItem[]> {
        const response = await this.dictionaryApi.dictionaries({
            keys: [DictionaryKeysEnum.STORES],
            filters: {
                [DictionaryKeysEnum.STORES]: {
                    store_groups_ids: storeGroupIds,
                },
            },
        });

        if (response.code === Code.Success) {
            return this._filterStores(
                this._responseDictionaryOptionToDictionaryItem(response.data.dictionaries[DictionaryKeysEnum.STORES]),
                allStores,
                selectedStores
            );
        }

        return [];
    }

    public async getStoreGroupsByStores(storeIds: number[]): Promise<DictionaryItem[]> {
        const response = await this.dictionaryApi.dictionaries({
            keys: [DictionaryKeysEnum.STORE_GROUPS],
            filters: {
                [DictionaryKeysEnum.STORE_GROUPS]: {
                    stores_ids: storeIds,
                },
            },
        });

        if (response.code === Code.Success) {
            return this._responseDictionaryOptionToDictionaryItem(response.data.dictionaries[DictionaryKeysEnum.STORE_GROUPS]);
        }

        return [];
    }

    public async getCompaniesByStores(storeIds: number[]): Promise<DictionaryItem[]> {
        const response = await this.dictionaryApi.dictionaries({
            keys: [DictionaryKeysEnum.COMPANIES],
            filters: {
                [DictionaryKeysEnum.COMPANIES]: {
                    stores_ids: storeIds,
                },
            },
        });

        if (response.code === Code.Success) {
            return this._responseDictionaryOptionToDictionaryItem(response.data.dictionaries[DictionaryKeysEnum.COMPANIES]);
        }

        return [];
    }

    private _filterStores(responseStores: DictionaryItem[], allStores: DictionaryItem[], selectedStores: DictionaryItem[]) {
        const matchedAllStores = allStores.filter((store) => {
            return responseStores.some((responseStore) => responseStore.id === store.id);
        });

        return matchedAllStores.filter((store) => {
            return !selectedStores.some((selectedStore) => selectedStore.id === store.id);
        });
    }

    private _responseDictionaryOptionToDictionaryItem(option: DictionaryOptionResource[]): DictionaryItem[] {
        return option.map((store) => ({
            id: Number(store.value),
            name: store.label,
        }));
    }
}
